import { CheckCircle2 } from "lucide-react";
import Seo from "@/components/Seo";

/**
 * Off-target thank-you page for /lp/prenota-call.
 *
 * Reached when the visitor selects "Sto cercando un lavoro" as `motivo_richiesta`
 * or "Disoccupato" as `ruolo`. Lead is still stored in the CRM (so we can route
 * it via workflow), but we do NOT fire the Meta Pixel `Lead` event: those
 * conversions must not count for advertising optimisation because they are
 * outside our ICP.
 */
export default function LandingAdsOffTarget() {
  return (
    <>
      <Seo
        title="Grazie — Lovac"
        description="Richiesta ricevuta."
        path="/lp/prenota-call/off-target"
        noindex
      />

      <div className="bg-lovac border-b border-lovac">
        <div className="container-lovac px-6 py-5 flex items-center">
          <img src="/images/logo-orizzontale.png" alt="Lovac" className="h-7 sm:h-8" />
        </div>
      </div>

      <section
        className="py-24 lg:py-32 bg-lovac-dark text-on-dark grain relative overflow-hidden min-h-[70vh] flex items-center"
        data-testid="lp-offtarget-section"
      >
        <div className="container-narrow relative z-10">
          <div className="text-center">
            <CheckCircle2 size={64} className="text-lovac-accent mx-auto" />
            <h1
              className="font-display text-4xl sm:text-5xl lg:text-6xl mt-8 text-on-dark leading-tight"
              data-testid="lp-offtarget-title"
            >
              Grazie per la tua richiesta.
            </h1>
            <p className="text-on-dark-muted mt-6 max-w-2xl mx-auto leading-relaxed text-lg">
              Al momento Lovac lavora solo con aziende che stanno cercando personale da assumere,
              non gestiamo candidature dirette. Se in futuro vorrai proporti come candidato per
              una nostra ricerca aperta, ti invitiamo a controllare periodicamente il sito.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
